import pinyin from './common/pinyin';
import dictIndex from './components/dict/index';
import dictEditor from './components/dict/editor';
import reportPanel from './components/report/report-panel';
import reportIndex from './components/report/report-index';

const components = [dictIndex, dictEditor, reportPanel, reportIndex];

const install = function (Vue) {
  if (install.installed) return;

  install.installed = true;

  components.forEach((com) => {
    Vue.component(com.name, com);
  });
};

export default {
  install,
  ...components,
};

export { pinyin, dictIndex, dictEditor, reportPanel, reportIndex };
